export default "__VITE_ASSET__02rwegQi__"